import React from 'react';
import classNames from 'classnames/bind';
import { Button } from '../../../components';
import styles from './styles.module.scss';
import Picture from '../../../components/Picture/Picture';
import { StaticUrls } from '../../../shared/static-urls-enum';

const cx = classNames.bind(styles);

const NumberFormatter = new Intl.NumberFormat('en-US');

type PlayItForwardProps = {
  showKids?: boolean;
  kidsEngaged: number;
  programsCompleted: number;
  volunteersMobilized: number;
  citiesActivated: number;
};

const PlayItForward: React.FC<PlayItForwardProps> = ({
  showKids = false,
  kidsEngaged,
  programsCompleted,
  volunteersMobilized,
  citiesActivated,
}) => (
  <div className={cx('playIt', 'pt-0')}>
    <div className={cx('details')}>
      <div className="container">
        <div className="row">
          <div className="col-12 col-md-6 my-auto">
            <h1 className={cx('title')}>Play It Forward</h1>
            <div className={cx('subtitle')}>The Volo Kids Foundation</div>
            <p>
              Our Foundation was established in 2015 in Baltimore in order to support the
              communities we played in. Volo Kids is on a mission to build communities of active,
              resilient, and confident kids. Over the last 7 years, we have been able to provide
              over 11,000 kids across 7 cities nationwide with free, quality youth sports
              programming. Since the COVID-19 pandemic, we now also offer virtual programming to
              keep kids active both on and off the field.
            </p>
            <p>
              We believe in creating a community that supports each other. Every purchase at Volo
              Sports, Volo Pass, or Volo Virtual supports The Volo Kids Foundation with part of the
              proceeds going toward funding our youth programs. Those who volunteer with the
              Foundation can receive free Volo Sport leagues or Volo Pass subscriptions.
            </p>
          </div>
          <div className="col-12 col-md-6">
            {showKids ? (
              <Picture
                src="https://rivall-public.s3-us-west-1.amazonaws.com/home-page/Virtual-Kids.png"
                alt="play it forward"
              />
            ) : (
              <Picture
                src="https://rivall-public.s3-us-west-1.amazonaws.com/home-page/play-it.png"
                alt="play it forward"
              />
            )}
          </div>
        </div>
      </div>
    </div>
    <div className={cx('infoRow', 'container')}>
      <div className="row">
        <div className="col-12 col-md-3 my-3">
          <div className={cx('card')}>
            <div className={cx('number')}>{NumberFormatter.format(kidsEngaged)}</div>
            <h3>Kids Engaged</h3>
            <p>
              Each kid receives a t-shirt (as their uniform) and healthy snack at every activity.
            </p>
            <a href={StaticUrls.VOLOKIDS_PLAY} target="_blank" rel="noopener noreferrer">
              <Button className={cx('blueButton')}>Register</Button>
            </a>
          </div>
        </div>
        <div className="col-12 col-md-3 my-3">
          <div className={cx('card')}>
            <div className={cx('number')}>{NumberFormatter.format(programsCompleted)}</div>
            <h3>Programs Completed</h3>
            <p>
              Volo provides programs in Baltimore, Boston, Washington DC, New York, Denver, San
              Francisco and San Diego today.
            </p>
            <a href={StaticUrls.VOLOKIDS_DONATE} target="_blank" rel="noopener noreferrer">
              <Button className={cx('blueButton')}>Donate</Button>
            </a>
          </div>
        </div>
        <div className="col-12 col-md-3 my-3">
          <div className={cx('card')}>
            <div className={cx('number')}>{NumberFormatter.format(volunteersMobilized)}</div>
            <h3>Volunteers Mobilized</h3>
            <p>Volunteers support each program and develop lasting relationships with each kid.</p>
            <a href={StaticUrls.VOLOKIDS_VOLUNTEER} target="_blank" rel="noopener noreferrer">
              <Button className={cx('blueButton')}>Become a Coach</Button>
            </a>
          </div>
        </div>
        <div className="col-12 col-md-3 my-3">
          <div className={cx('card')}>
            <div className={cx('number')}>{NumberFormatter.format(citiesActivated)}</div>
            <h3>Cities Activated</h3>
            <p>Volunteer and support your city and play for free in a Volo Sports league!</p>
            <a href={StaticUrls.VOLOKIDS_VOLUNTEER} target="_blank" rel="noopener noreferrer">
              <Button className={cx('blueButton')}>Volunteer</Button>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
);

export default PlayItForward;
